import { ErrorMessageResponseContainer, StoreStockSapInventory } from './data-contracts';
import { HttpClient, RequestParams, TraceDataType } from './http-client';

import { loggerCan } from '@/data/utils/loggerUtil';
import { logger } from '@/logging/logger';

export class SapInventory<SecurityDataType = unknown> {
	http: HttpClient<SecurityDataType>;

	constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
	}

	/**
	 * No description
	 *
	 * @tags sap-inventory
	 * @name SapInventoryAvailabilityGetStoreInventoryByStoreNumbersAndPartNumberDetail
	 * @summary Fetch store stock by store ids and part number.
	 * @request GET:/store/{storeId}/sap_inventory_availability/getStoreInventoryByStoreNumbersAndPartNumber
	 * @secure
	 * @response `200` `StoreStockSapInventory` The requested completed successfully.
	 * @response `400` `void` Bad request. The request could not be understood by the server due to malformed syntax.
	 * @response `401` `void` Not authenticated. The user session is not valid.
	 * @response `403` `void` The user is not authorized to perform the specified request.
	 * @response `404` `void` The specified resource could not be found.
	 * @response `500` `void` Internal server error. For details, see the server log files.
	 */
	sapInventoryAvailabilityGetStoreInventoryByStoreNumbersAndPartNumberDetail = (
		storeId: string,
		query: {
			/** Physical store ids, seperated by comma */
			storeNumber: string;
			/** Part number */
			partNumber: string;
			/** Part number */
			hasLimit?: boolean;
			/** Part number */
			isOrder?: boolean;
			/** Delivery type */
			deliveryType?: string;
			/** Delivery type */
			productIds?: string;
			/** Delivery type */
			orderId?: string;
			/** Delivery type */
			zipCode?: string;
		},
		params: RequestParams = {}
	) => {
		const { _requestId: requestId, skipErrorLogging, ..._params } = params as any;
		let traceData: TraceDataType | undefined;

		if (
			loggerCan('trace') &&
			(!this.http.traceDetails ||
				this.http.traceDetails[
					'sapInventoryAvailabilityGetStoreInventoryByStoreNumbersAndPartNumberDetail'
				])
		) {
			traceData = {
				requestId,
				msg: 'API request',
				url: `${this.http.baseUrl}/store/${storeId}/sap_inventory_availability/getStoreInventoryByStoreNumbersAndPartNumber`,
				params: _params,
				query: query,
				methodName: 'sapInventoryAvailabilityGetStoreInventoryByStoreNumbersAndPartNumberDetail',
			};
			logger.trace(traceData);
		}
		return this.http.request<StoreStockSapInventory, void>({
			path: `/store/${storeId}/sap_inventory_availability/getStoreInventoryByStoreNumbersAndPartNumber`,
			method: 'GET',
			query: query,
			secure: true,
			format: params.format ?? 'json',
			storeId,
			traceData,
			skipErrorLogging,
			..._params,
		});
	};
	/**
 * No description
 *
 * @tags sap-inventory
 * @name SapInventoryAvailabilityCheckInventoryByOrderIdDetail
 * @summary Check store inventory availability for the items in an order by order id.
 * @request GET:/store/{storeId}/sap_inventory_availability/check_inventory/byOrderId/{orderId}
 * @secure
 * @response `200` `{
    allItemsHaveStockInSAP?: string,

}` The requested completed successfully.
 * @response `400` `ErrorMessageResponseContainer` Bad request. The request could not be understood by the server due to malformed syntax.
 * @response `401` `void` Not authenticated. The user session is not valid.
 * @response `403` `void` The user is not authorized to perform the specified request.
 * @response `404` `void` The specified resource could not be found.
 * @response `500` `void` Internal server error. For details, see the server log files.
 */
	sapInventoryAvailabilityCheckInventoryByOrderIdDetail = (
		storeId: string,
		orderId: string,
		query: {
			/** source identifier, ex: shoppingcart */
			source: string;
			/** stloc store id. */
			physicalStoreId: string;
		},
		params: RequestParams = {}
	) => {
		const { _requestId: requestId, skipErrorLogging, ..._params } = params as any;
		let traceData: TraceDataType | undefined;

		if (
			loggerCan('trace') &&
			(!this.http.traceDetails ||
				this.http.traceDetails['sapInventoryAvailabilityCheckInventoryByOrderIdDetail'])
		) {
			traceData = {
				requestId,
				msg: 'API request',
				url: `${this.http.baseUrl}/store/${storeId}/sap_inventory_availability/check_inventory/byOrderId/${orderId}`,
				params: _params,
				query: query,
				methodName: 'sapInventoryAvailabilityCheckInventoryByOrderIdDetail',
			};
			logger.trace(traceData);
		}
		return this.http.request<
			{
				allItemsHaveStockInSAP?: string;
			},
			ErrorMessageResponseContainer | void
		>({
			path: `/store/${storeId}/sap_inventory_availability/check_inventory/byOrderId/${orderId}`,
			method: 'GET',
			query: query,
			secure: true,
			format: params.format ?? 'json',
			storeId,
			traceData,
			skipErrorLogging,
			..._params,
		});
	};
}
